<template>
  <div class="big">
    <AddGenericName v-if="addGeneric" @closeShow="closeShow"></AddGenericName>
    <EditGenericName
      v-if="editGeneric"
      @closeShow="closeShow"
      :nameData="nameData"
    ></EditGenericName>
    <EditAliasName
      v-if="editAlias"
      @closeShow="closeShow"
      :nameData="nameData"
    ></EditAliasName>
    <ImportData v-if="importData" @closeShow="closeShow"></ImportData>
    <EditReplaceName
      v-if="replaceName"
      @closeShow="closeShow"
      :nameData="nameData"
    ></EditReplaceName>
    <div class="page_title">药品通用名维护</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="searchbox">
          <div>
            <span>通用名</span>
            <el-input
              v-model="simple_pname"
              placeholder="请输入"
              style="width: 160px; margin: 0 12px 0 5px"
              @input="search"
              clearable
            ></el-input>
            <span>ID</span>
            <el-input
              v-model="drug_id"
              placeholder="请输入"
              style="width: 160px; margin: 0 12px 0 5px"
              @input="search"
              clearable
            ></el-input>
            <span>别名</span>
            <el-input
              v-model="alias"
              placeholder="请输入"
              style="width: 160px; margin: 0 12px 0 5px"
              @input="search"
              clearable
            ></el-input>
            <span>煎法</span>
            <el-input
              v-model="requirement"
              placeholder="请输入"
              style="width: 160px; margin: 0 12px 0 5px"
              @input="search"
              clearable
            ></el-input>
            <el-button
              type="info"
              size="medium"
              style="
                background-color: #eceff2;
                color: #747981;
                margin-right: 20px;
              "
              @click="search"
              >查询</el-button
            >
          </div>
          <div>
            <el-button
              type="primary"
              plain
              @click="importData = true"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('890') : false
              "
              >导入排序值</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="addGeneric = true"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('410') : false
              "
              >新增通用名</el-button
            >
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              label="通用名称"
              prop="generic_name"
            ></el-table-column>

            <el-table-column label="ID" prop="drug_id"></el-table-column>

            <el-table-column label="排序">
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.sort"
                  :min="1"
                  :max="99999"
                  :precision="0"
                  :controls="false"
                  style="width: 100px"
                  @change="
                    (value) => {
                      return updateSort(value, scope.row.drug_id);
                    }
                  "
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('889')
                      : false
                  "
                ></el-input-number>
              </template>
            </el-table-column>

            <el-table-column
              label="企标当量"
              prop="xly_standard"
            ></el-table-column>
            <el-table-column
              label="国标当量"
              prop="national_standard"
            ></el-table-column>
            <el-table-column
              label="转化率"
              prop="conversion_rate_standard"
            ></el-table-column>
            <el-table-column
              label="颗粒饮片当量"
              prop="conversion"
            ></el-table-column>

            <el-table-column label="全拼" prop="full_pname">
              <template slot-scope="scope">
                <div @dblclick="editname(scope.row, 1)" style="">
                  {{ scope.row.full_pname }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="简拼" prop="simple_pname">
              <template slot-scope="scope">
                <div @dblclick="editname(scope.row, 1)" style="">
                  {{ scope.row.simple_pname }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="别名" prop="alias">
              <template slot-scope="scope">
                <div @dblclick="editname(scope.row, 2)" v-if="scope.row.alias">
                  {{ scope.row.alias }}
                </div>
                <el-button type="text" v-else @click="editname(scope.row, 2)"
                  >编辑别名</el-button
                >
              </template>
            </el-table-column>
            <el-table-column label="可代替药品">
              <template slot-scope="scope">
                <div
                  @dblclick="editname(scope.row, 4)"
                  v-if="scope.row.replace_drug_name"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1012')
                      : false
                  "
                >
                  {{ scope.row.replace_drug_name }}
                </div>
                <el-button
                  type="text"
                  v-else
                  @click="editname(scope.row, 4)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1012')
                      : false
                  "
                  >编辑可替代药品</el-button
                >
              </template>
            </el-table-column>
            <el-table-column label="煎法" prop="requirement">
              <template slot-scope="scope">
                <el-dropdown
                  @command="
                    (command) => {
                      return editname(command, 3, scope.row.drug_id);
                    }
                  "
                  trigger="click"
                  placement="bottom"
                >
                  <span
                    class="el-dropdown-link"
                    style="color: #333; cursor: pointer"
                  >
                    <span v-if="scope.row.requirement">
                      {{ scope.row.requirement }}
                    </span>
                    <el-button type="text" v-else>编辑煎法</el-button>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item, index) in decoctingList"
                      :key="index"
                      :command="item.decocting_name"
                      >{{ item.decocting_name }}</el-dropdown-item
                    >
                    <el-dropdown-item
                      command=""
                      v-if="scope.row.requirement"
                      style="color: red"
                      >取消煎法</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
            <el-table-column label="特殊药品" prop="generic_name" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.special_drug == 0">否</span>
                <span v-if="scope.row.special_drug == 1">是</span>
              </template>
            </el-table-column>
            <el-table-column
              label="用量提醒值"
              prop="special_drug_level"
              width="120"
            ></el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin: 20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AddGenericName from "./AddGenericName";
import EditGenericName from "./EditGenericName";
import EditAliasName from "./EditAliasName";
import ImportData from "./ImportData.vue";
import EditReplaceName from "./EditReplaceName.vue";
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      addGeneric: false,
      editGeneric: false,
      editAlias: false,
      importData: false,
      replaceName: false,
      simple_pname: "",
      drug_id: "",
      alias: "",
      requirement: "",
      nameData: {},
      decoctingList: [],
    };
  },
  components: {
    AddGenericName,
    EditGenericName,
    EditAliasName,
    ImportData,
    EditReplaceName,
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        simple_pname: this.simple_pname,
        drug_id: this.drug_id,
        alias: this.alias,
        requirement: this.requirement,
      };
      this.axios.post("platform/template/getDrugTcmList", data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list;
          this.totalNum = res.data.total;
        }
      });
    },
    //获取煎法列表
    getSystemDecocting() {
      this.axios.post("platform/template/getSystemDecocting").then((res) => {
        if (res.code == 0) {
          this.decoctingList = res.data.list;
        }
      });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    closeShow() {
      this.addGeneric = false;
      this.editGeneric = false;
      this.addAlias = false;
      this.editAlias = false;
      this.importData = false;
      this.replaceName = false;
      this.getList();
    },
    editname(row, type, drug_id) {
      this.nameData = row;
      if (type == 1) {
        this.editGeneric = true;
      } else if (type == 2) {
        this.editAlias = true;
      } else if (type == 3) {
        let data = {
          drug_id,
          requirement: row,
        };
        this.axios
          .post("platform/template/updateDrugTcmrEquirement", data)
          .then((res) => {
            if (res.code == 0) {
              this.$message.success("保存成功");
              this.getList();
            }
          });
      } else if (type == 4) {
        this.replaceName = true;
      }
    },
    //排序
    updateSort(value, drug_id) {
      if (!value) {
        this.getList();
        return false;
      }
      let data = {
        sort: value,
        drug_id,
      };
      this.axios
        .post("platform/template/updateDrugTcmSort", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("保存成功");
            this.getList();
          }
        });
    },
  },
  created() {
    this.getList();
    this.getSystemDecocting();
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
</style>
